import { useRouter } from '@tribeplatform/react-sdk';
export const getSearchParams = (search) => {
    const urlSearchParams = new URLSearchParams(search);
    const queryParams = {};
    urlSearchParams.forEach((value, key) => {
        queryParams[key] = value;
    });
    return queryParams;
};
export const useQuery = () => {
    const { location } = useRouter();
    return getSearchParams(location.search);
};
//# sourceMappingURL=useQuery.js.map